import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import AjaxContent from "../../modules/AjaxContent";
import Modal from "../../modules/Modal";
import { AnchorElementKind, AnchorElementTags } from "./AnchorTypes";

var Anchor = /*#__PURE__*/function (_React$Component) {
  _inherits(Anchor, _React$Component);

  var _super = _createSuper(Anchor);

  function Anchor() {
    var _this;

    _classCallCheck(this, Anchor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Anchor.displayName));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isModalOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseModal", function () {
      _this.setState({
        isModalOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      event.preventDefault();

      if (_this.props.onClick) {
        _this.props.onClick();
      } else {
        _this.setState({
          isModalOpen: true
        });
      }
    });

    return _this;
  }

  _createClass(Anchor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contentLocation = _this$props.contentLocation,
          disabled = _this$props.disabled,
          download = _this$props.download,
          fallbackElementTag = _this$props.fallbackElementTag,
          href = _this$props.href,
          kind = _this$props.kind,
          modalLabel = _this$props.modalLabel,
          newWindow = _this$props.newWindow,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick,
          reactFromMarkupOptions = _this$props.reactFromMarkupOptions,
          reactFromMarkupRehydrators = _this$props.reactFromMarkupRehydrators,
          children = _this$props.children,
          innerRef = _this$props.innerRef,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? "" : _this$props$title,
          id = _this$props.id,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["contentLocation", "disabled", "download", "fallbackElementTag", "href", "kind", "modalLabel", "newWindow", "onChange", "onClick", "reactFromMarkupOptions", "reactFromMarkupRehydrators", "children", "innerRef", "title", "id", "className"]);

      var classNameFull = "".concat(this.getClassName(), " ").concat(className || ""); // eslint-disable-next-line
      // TODO: AnchorElement should be its own component

      var elementProps = {
        title: title
      };
      var AnchorElement;

      if (innerRef) {
        elementProps.ref = innerRef;
      } // eslint-disable-next-line
      // TODO: clean up this flow control, its hard to follow


      if (kind === AnchorElementKind.LINK) {
        AnchorElement = fallbackElementTag;

        if (href) {
          AnchorElement = AnchorElementTags.LINK;
          elementProps.href = href;
          elementProps.download = download;
        }

        if (newWindow) {
          elementProps.target = "_blank";
          elementProps.rel = "noopener";
        }
      } else {
        AnchorElement = AnchorElementTags.BUTTON;
        elementProps.type = kind;
        elementProps.disabled = disabled;
      }

      var shouldRehydrate = Boolean(contentLocation);
      /**
       * `data-content-modal` provides us an identifier which
       * the wel-trdotcom global modal click handlers can
       * match against.
       */

      if (shouldRehydrate) {
        elementProps["data-content-location"] = contentLocation;
        elementProps["data-modal-label"] = modalLabel;
        elementProps["data-content-modal"] = true;
      }

      if (id) {
        elementProps.id = id;
      }

      var shouldHandleClick = contentLocation || onClick;

      if (shouldHandleClick) {
        elementProps.onClick = this.handleOnClick;
      }

      return /*#__PURE__*/React.createElement(AnchorElement, _extends({
        className: classNameFull
      }, elementProps, rest), children, this.state.isModalOpen && /*#__PURE__*/React.createElement(Modal, {
        ariaLabel: modalLabel,
        closeLabel: "Close",
        closeThisComponent: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(AjaxContent, {
        failedContent: "Failed to retrieve content",
        loadingLabel: "Loading",
        location: contentLocation,
        onChange: onChange,
        reactFromMarkupOptions: reactFromMarkupOptions,
        reactFromMarkupRehydrators: reactFromMarkupRehydrators
      })));
    }
  }]);

  return Anchor;
}(React.Component);

_defineProperty(Anchor, "displayName", "Anchor");

_defineProperty(Anchor, "defaultProps", {
  kind: AnchorElementKind.LINK,
  fallbackElementTag: AnchorElementTags.SPAN
});

export default Anchor;